import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "@/environments/environment";
import { HttpParams } from '@angular/common/http';

@Injectable({
    providedIn: "root",
})
export class AfpBatchService {
    private endpoints = environment.endPoints;

    constructor(private http: HttpClient) { }

    /** Get all batches */
    getAllBatches(): Observable<any> {
        return this.http.get(this.endpoints.afpBatches.list);
    }

    /** Create a new batch */
    createBatch(payload: any): Observable<any> {
        return this.http.post(this.endpoints.afpBatches.store, payload);
    }

    /** Update jobs in a batch */
    updateJobsInBatch(batchId: string | number, payload: any): Observable<any> {
        return this.http.post(
            this.endpoints.afpBatches.updateJobs(batchId),
            payload,
        );
    }

    sendToInvoice(payload: any) {
        return this.http.post(
            this.endpoints.afpBatches.sendToInvoice,
            payload,
        );
    }

    updateCustomerOrderNumber(batchId: string | number, customerOrderNo: string) {
        return this.http.post(
            this.endpoints.afpBatches.updateCustomerOrderNumber(batchId),
            { customerOrderNo },
        );
    }

    /** lock batch */
    lockBatch(batchId: string | number): Observable<any> {
        return this.http.post(this.endpoints.afpBatches.lockBatch(batchId), {});
    }
    /** Get jobs inside a specific batch */
    getBatchJobs(batchId: string | number): Observable<any> {
        return this.http.get(this.endpoints.afpBatches.get(batchId));
    }

    /** Export jobs based on type and batch */
    exportJobs(type: string, batchId: number | string): Observable<any> {
        const url = `${this.endpoints.afpJobs.export}?type=${encodeURIComponent(type)
            }&batch_id=${batchId}`;
        return this.http.get(url, { responseType: "blob" }); // 'blob' for file download
    }

    importJobs(file: File, type: string): Observable<any> {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("type", type);
        return this.http.post(this.endpoints.afpJobs.import, formData, { responseType: 'text' });
    }

    /** Get batch invoice details */
    getBatchInvoicesDetails(batchId: number | string): Observable<any> {
        return this.http.get(this.endpoints.afpBatches.batchInvoice(batchId));
    }

    updateBatch(payload: any, id: number): Observable<any> {
        return this.http.post(this.endpoints.afpBatches.update(id), payload);
    }

    getBatchSummary(ids: HttpParams): Observable<any> {
        return this.http.get(this.endpoints.afpBatches.getBatchSummary, { params: ids, responseType: 'blob' });
    }

    getAllCollections(): Observable<any> {
        return this.http.get(this.endpoints.afpCollections.list);
    }

    createCollection(payload: any): Observable<any> {
        return this.http.post(this.endpoints.afpCollections.store, payload);
    }

    getBatchesByCollectionId(collectionId: string | number): Observable<any> {
        return this.http.get(this.endpoints.afpCollections.collectionBatches(collectionId));
    }

    invoiceCollection(payload: any): Observable<any> {
        return this.http.post(this.endpoints.afpCollections.invoice, payload);
    }

    getReportOptions(): Observable<any> {
        return this.http.get(this.endpoints.afpBatches.getReportOptions);
    }

    generateReport(payload: any) {
        return this.http.post(this.endpoints.afpBatches.generateReport, payload);
    }
    /** Get bulk invoice status */
    getBulkInvoiceStatus(jobId: string): Observable<any> {
        // Use the base jobs API path, not the sendToInvoice endpoint
        const baseUrl = this.endpoints.afpBatches.sendToInvoice.replace('/post-afp-invoice', '');
        return this.http.get(`${baseUrl}/bulk-invoice/status/${jobId}`);
    }

}
